import React, { useEffect } from 'react';
import '../.././styles/alumni.scss';
import { saveCookies } from '../../hooks';
import VerifyAccountView from './VerifyAccountContentView';
import Footer from './Footer';
import { recordEvent } from 'src/analytics/amplify';

function VerifyAccountScreen() {
    saveCookies();
    useEffect(() => {
        recordEvent({
            name: 'VerifyAccountScreen.Render'
        });
    }, []);

    return(
        <div className="fullscreen">
            <div className="activation-flow-flex-container">
                <div className="flex-box-right">
                    <div data-testid="verifyAccountContent" className="activation-flow-content-wrap">
                        < VerifyAccountView />
                    </div>
                    <div data-testid="footer" className="footer-container">
                        <Footer screen="VerifyAccountScreen"/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VerifyAccountScreen;
